module.exports = __webpack_public_path__ + "static/img/wei.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/wei.jpg
// module id = QmSx
// module chunks = 0